import { RESTRICTED_ACCESSS_TOOLTIP_TEXT } from '@modules/common/components/CanAccess/constants';
import { useIsAuthorized } from '@modules/common/components/CanAccess/hooks';
import { Box } from '@mui/material';
import Tooltip, { TooltipProps } from '@mui/material/Tooltip';
import { PermissionOperation } from 'generated/graphql';
import { PermissionResourceType } from 'v2/core/entities/user';

interface CanAccessProps {
  resource: PermissionResourceType;
  operation: PermissionOperation;
  children: JSX.Element;
  tooltipPlacement?: TooltipProps['placement'];
  tooltipFollowCursor?: TooltipProps['followCursor'];
  shouldHideIfRestricted?: boolean;
  wrapper?: 'inline' | 'block';
  shouldPersistOpacity?: boolean;
  canAccess?: boolean;
}

const CanAccess = ({
  resource,
  operation,
  children,
  tooltipPlacement = 'bottom',
  tooltipFollowCursor,
  wrapper = 'block',
  shouldHideIfRestricted,
  shouldPersistOpacity = false,
  canAccess,
}: CanAccessProps) => {
  const shouldShowChildren =
    useIsAuthorized({
      operation,
      resource,
    }) || canAccess;

  if (shouldShowChildren) {
    return children;
  }

  if (shouldHideIfRestricted) {
    return null;
  }

  return (
    <Tooltip
      title={RESTRICTED_ACCESSS_TOOLTIP_TEXT}
      placement={tooltipPlacement}
      followCursor={tooltipFollowCursor}
      arrow
    >
      <Box
        sx={{
          display: wrapper,
          cursor: 'not-allowed',
          '& > *': {
            pointerEvents: 'none',
            opacity: shouldPersistOpacity ? 'unset' : 0.65,
          },
        }}
      >
        {children}
      </Box>
    </Tooltip>
  );
};

export default CanAccess;
